module.exports = __webpack_public_path__ + "img/w80.2d584c50.svg";